<script setup lang="ts">
import type { IconDefinition } from '@fortawesome/pro-light-svg-icons'

defineProps<{ icon?: string | IconDefinition; iconClass?: string }>()

</script>

<template>
  <button
    class="
      header-button
      flex items-center justify-center gap-3
      rounded-v2md border-1 border-solid border-grey-primary
      active:text-navy lg:hover:text-navy
      text-v2-tertiary
      relative
    "
    style="height: 44px; width: 44px;"
  >
    <GIcon v-if="icon" :icon="icon" size="sm" :class="iconClass"/>
    <slot/>
  </button>
</template>
